import { RouterModule, Routes } from '@angular/router';
import { HomeTransferComponent } from './components/home-transfer/home-transfer.component';
import { ListTransferComponent } from './components/list-transfer/list-transfer.component';
import { ViewTransferComponent } from './components/view-transfer/view-transfer.component';


import { TechnicalServiceGuard } from '../guards/technicalService.guard';



export const TransferRouter: Routes = [
    { path: '', component: HomeTransferComponent , canActivate: [TechnicalServiceGuard]},
    { path: 'create', component: ViewTransferComponent , canActivate: [TechnicalServiceGuard]},
    { path: 'view/:id', component: ViewTransferComponent , canActivate: [TechnicalServiceGuard]},
    { path: 'list', component: ListTransferComponent , canActivate: [TechnicalServiceGuard]},
];


// WEBPACK FOOTER //
// ./src/app/transfer/transfer.router.ts